var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterviewExpired({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 18.3337C14.6025 18.3337 18.3334 14.6027 18.3334 10.0003C18.3334 5.39795 14.6025 1.66699 10.0001 1.66699C5.39771 1.66699 1.66675 5.39795 1.66675 10.0003C1.66675 14.6027 5.39771 18.3337 10.0001 18.3337ZM10.8681 5.83366C10.8681 5.35425 10.4795 4.9656 10.0001 4.9656C9.52067 4.9656 9.13203 5.35425 9.13203 5.83366V10.0003C9.13203 10.2305 9.22348 10.4513 9.38627 10.6141L12.3326 13.5604C12.6716 13.8994 13.2212 13.8994 13.5602 13.5604C13.8992 13.2214 13.8992 12.6718 13.5602 12.3328L10.8681 9.64076V5.83366Z",
    fill: "#70758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewExpired);
export default __webpack_public_path__ + "static/media/interview-expired.3b6af89490aa50a52e64b60368286afc.svg";
export { ForwardRef as ReactComponent };